import axios from './base'

export const getProfiles = (): Promise<any> => axios.get(`/v2/profiles`)
export const createProfile = (payload: any): Promise<any> => axios.post(`/v2/profiles`, payload)
export const updateProfile = (id: string, payload: any): Promise<any> => axios.put(`/v2/profiles/${id}`, payload)
export const getUserProfiles = (user_id: number): Promise<any> => axios.get(`/v2/user/${user_id}/profiles`)
